import { Button, Link } from '@mui/material'
import { Page } from 'components/Shared/Page'
import { Link as RouterLink } from 'react-router-dom'
import { PageHeader } from 'components/Shared/PageHeader'
import { BadgesTable } from 'components/Badges/BadgesTable'

export const LocationBadgesPage = () => {
  return (
    <Page
      header={
        <PageHeader
          title="Location Badges"
          eyebrow="CONTESTS"
          actionButton={
            <Link to="/Contests/LocationBadges/New" component={RouterLink}>
              <Button variant="contained" fullWidth>
                Create New Location Badge
              </Button>
            </Link>
          }
        />
      }
    >
      <BadgesTable category="LocationBadge" />
    </Page>
  )
}
